<template>
    <div class="containerMeh">
            <div class="addNewMeh">
                <div class="mehTitle">
                    <h1>הוספת מוצר ומחירון</h1>
                </div>
                <div class="mehForm">
                    <div class="mehInputField">
                        <input type="text" placeholder="שם המוצר" v-model="productName">
                    </div>
                    <div class="mehInputField">
                        <input type="number" placeholder="מחירון ₪"  v-model="productPrice">
                    </div>
                    <div class="mehInputField">
                        <!-- <input type="text" placeholder="שם הספק" v-model="dealerName"> -->
                        <select v-model="dealerName">
                            <option value="" selected> -- בחר שם הספק -- </option>
                            <option :value="dealer.Data.selectDealerName" v-for="dealer in Dealers" >{{ dealer.Data.selectDealerName }}</option>
                        </select>
                    </div>
                    <div class="mehInputField">
                        <input type="file"  @change="uploadImage">
                    </div>
                    <div class="mehInputField">
                        <input type="submit" @click="addProductMeheron()" >
                    </div>
                </div>
            </div>

            <!-- DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD   -->
<!-- <br> -->
            <!-- <div class="addNewMeh">
                <div class="mehTitle">
                    <h1>הוספת ספק חדש</h1>
                </div>
                <div class="mehForm">
                    <div class="mehInputField">
                        <input type="text" placeholder="הוספת ספק חדש" v-model="selectDealerName">
                    </div>
                    <div class="mehInputField">
                        <input type="submit" @click="addDealer()" >
                    </div>
                </div>
            </div> -->




            <div class="loadProducts">
                <button class="edit-btn" @click="EditProduct = !EditProduct"><i class="material-icons">edit</i></button>

                <div class="product" v-for="product in Meheronem" v-if="EditProduct">

                    <img :src="product.Data.productImg" alt="" >
                    <span class="prodName" >{{ product.Data.productName }}</span>
                    <span class="prodPrice">₪{{ product.Data.productPrice }} </span>
                    <span class="prodDealer">{{ product.Data.dealerName }}</span>   

                </div>
                <div class="product" v-for="eProduct in Meheronem" v-else>

                    <img :src="eProduct.Data.productImg" alt="" >
                    <input type="text" v-model="eProduct.Data.productName">
                    <input type="text" v-model="eProduct.Data.productPrice">  
                    <input type="text" v-model="eProduct.Data.dealerName">     

                </div>
                
            </div>
    </div>
</template>

<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
export default {
  name: 'Meheron',

  data () {
    return {
      productName:"",
      productPrice:"",
      dealerName:"",
      quantity:0,
      productImg:"",
      Meheronem:[],
      Dealers:[],
      selectDealerName:"",
      EditProduct: true

    }
  },
  created(){
    let vm = this;
    vm.loadProducts();
    vm.loadDealers();
    if(vm.$root.loggedUser.Type !== 'Admin'){
        alert("אין לך גישה לדף הזה");
        vm.$router.go(-1);
    }
  },
  methods:{
    addProductMeheron (){
    let vm = this;
    if (vm.productName.length > 0 && vm.productPrice.length > 0 && vm.dealerName.length > 0){
      let ProductMeheron = {
        productName: vm.productName,
        productPrice: vm.productPrice,
        dealerName: vm.dealerName,
        productImg: vm.productImg,
        quantity: vm.quantity,
        createdDate: moment().format('LLLL')
      }
    
    db.collection("Meheron").add(ProductMeheron)
        .then(function(MeheronResult){   
          vm.productName="";
          vm.productPrice="";
          vm.dealerName="";
          vm.quantity="";
          vm.productImg="";
            console.log("Add ( Product Meheron ) Success");
            console.log(MeheronResult);
            location.reload();
        })
        .catch(function(error){
            console.error('add( Product Meheron ) Error !');
            console.error(error);
        });
        }

      },
      addDealer(){
    let vm = this;
    if (vm.selectDealerName.length > 0 ){
      let DealerMeheron = {
        selectDealerName: vm.selectDealerName,
        createdDate: moment().format('LLLL')
      }
    
    db.collection("Dealers").add(DealerMeheron)
        .then(function(DealerResult){   
          vm.selectDealerName="";
            console.log("Add ( DealerResult ) Success");
            console.log(DealerResult);
            location.reload();
        })
        .catch(function(error){
            console.error('add( DealerResult ) Error !');
            console.error(error);
        });
        }

      },
      uploadImage(e){
        let file = e.target.files[0];
        let storageRef = firebase.storage().ref('ProductsMeheronem/' + file.name);

        let uploadTask = storageRef.put(file);

        // Register three observers:
        // 1. 'state_changed' observer, called any time the state changes
        // 2. Error observer, called on failure
        // 3. Completion observer, called on successful completion
        uploadTask.on('state_changed', 
          (snapshot) => {
          },
          (error) => {
            // Handle unsuccessful uploads
          }, 
          () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.productImg = downloadURL;
              console.log('File available at', downloadURL);
            });
          }
        );
        },
        loadProducts(){
          let vm = this;
          vm.Meheronem = [];
          db.collection("Meheron").orderBy("createdDate","desc").get()
          .then(function(MeheronResult){
                  for(let a = 0; a < MeheronResult.size; a++){
                      let productId = MeheronResult.docs[a].id;
                      let product = MeheronResult.docs[a].data();
                      console.log(MeheronResult.size);
                      vm.Meheronem.push({ ID: productId, Data: product });
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
      loadDealers(){
          let vm = this;
          vm.Meheronem = [];
          db.collection("Dealers").orderBy("createdDate","desc").get()
          .then(function(DealerMeheron){
                  for(let a = 0; a < DealerMeheron.size; a++){
                      let dealerId = DealerMeheron.docs[a].id;
                      let dealer = DealerMeheron.docs[a].data();
                      console.log(DealerMeheron.size);
                      vm.Dealers.push({ ID: dealerId, Data: dealer });
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
  }

}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap');

.containerMeh{
    padding:1rem;
    height: 100%;

}
.addNewMeh{
    width: 100%;
    background-color: #fcfcfc;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 1rem;
}
.addNewMeh .mehTitle h1{
    font-size: 20px;
    color: var(--grey);
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
}
.mehForm{
    width: 100%;
    background-color: transparent;
    margin: 1rem 0rem;
}
.mehInputField{
    display: inline-block;
    width: calc(100% / 5 - 5px);
    padding: 0px 0px 0 15px;
    vertical-align: middle;
}
.mehInputField input,
.mehInputField select{
    width: 100%;
    height: 37px;
    padding: 0 10px;
    font-size: 14px;
    border: 1px solid #eee;
    outline: none;
    transition: 0.3s;
}

.mehInputField input[type=submit]{
    width: 100%;
    height: 37px;
    font-size: 14px;
    outline: none;
    transition: 0.3s;
    background-color: #baf3e6;
    color: #004d5a;
    padding-right: 0px;
    border: 0;
    font-weight: 700;
}
.mehInputField input[type=file]{
    width: 100%;
    height: 37px;
    padding: 4px 10px;
    font-size: 14px;
    border: 1px solid #eee;
    outline: none;
    transition: 0.3s;
}
.mehInputField input:hover,
.mehInputField select:hover{
    border: 1px solid #c7c7c7;
}
.loadProducts{
    width: 100%;
    margin: 1rem 0 ;
    background-color: yellow;
}
.loadProducts .product{
    float: right;
    width: calc(100% / 6 - 10px);
    border: 2px solid #eee;
    height: 300px;
    border-radius: 8px;
    margin: 5px;
    overflow: hidden;
    padding: 1rem;
    position: relative;
}
.product img{
    width: 100%;
    height: 150px;
}
.product .prodName{
    font-size: 16px;
    font-weight: 500;
    color: #666;
    display: block;
    margin-top: 10px;
    font-family: 'Heebo';
}
.product .prodDealer{
    font-size: 14px;
    font-weight: 500;
    color: #666;
    display: block;
    position: absolute;
    bottom: 20px;
}
.product .prodPrice{
    font-size: 16px;
    font-weight: 500;
    color: #000;
    display: block;
    position: absolute;
    left: 20px;
    max-width: 15ch;
    overflow: hidden;
    white-space: nowrap;
}
.edit-btn{
    font-size: 16px;
    text-align: center;
    display: flex;
    padding: 5px;
    border: 0;
    outline: 0;
    color: #666;
    background-color: #eee;
}
.edit-btn > i {
    font-size: 16px;
}
</style>



<!-- 


    <h1>הוספת מוצר ומחירון</h1>

    
 -->


// WEBPACK FOOTER //
// src/pages/Meheron.vue